// =============================================================================
// funnelLabel — arrival-funnel event_type → human chip label
// =============================================================================
// SHARED across every Dial Analytics lead surface (Due tab tables, All-Dials
// feed, per-dialer Connects panel) so a lead's funnel reads identically no matter
// where it appears. Mako's ask (2026-07-05): "no label of what this lead is — is
// it a webinar lead, a typeform lead... typeform? call booked? webinar?".
//
// The three funnels are the arrival event_types on `transactions` that seed a
// dialing lead (verified live on Rayston 2026-07-05: webinar 21.6k, typeform
// 8.7k, call_booked 5.8k). Anything else (or NULL for an unlinked dial) → null,
// which renders NO chip rather than a raw enum string.
// =============================================================================

const FUNNEL_LABELS: Record<string, string> = {
  typeform_submission: "Typeform",
  webinar_signup: "Webinar",
  call_booked: "Call Booked",
  dqwebinarsignup: "DQ Webinar",
};

/** Returns the chip label for a funnel source, or null (→ render no chip). */
export const funnelLabel = (source: string | null | undefined): string | null =>
  source ? (FUNNEL_LABELS[source] ?? null) : null;
